// extracted by mini-css-extract-plugin
module.exports = {"buttonCell":"Permissions_buttonCell__1qMhb","cellStile":"Permissions_cellStile__1iaDH"};